var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"dashboard",staticStyle:{"background-color":"#F0F0F0"},attrs:{"title":"Fakturering"}},[_c('new-table-view',{staticClass:"list",attrs:{"columns":[
			{
				label: 'Kunde',
				name: 'name',
				weight: '10fr'
			},
			{
				label: 'Åbne',
				data: ' ',
				align: 'right'
			},
			{
				label: '30',
				name: ['_embedded', 'status', 'open_tasks'],
				align: 'right',
				weight: '100px'
			},
			{
				label: '144.450,00',
				name: ['_embedded', 'status', 'open_value'],
				align: 'right',
				filter: 'number',
				weight: '200px'
			},
			{
				label: 'Fakturerbare',
				data: ' ',
				weight: '200px',
				align: 'right'
			},
			{
				label: '22',
				name: ['_embedded', 'status', 'invoicable_tasks'],
				align: 'right',
				weight: '100px'
			},
			{
				label: '100.600,00',
				name: ['_embedded', 'status', 'invoicable_value'],
				align: 'right',
				filter: 'number',
				weight: '200px'
			},
		],"items":_vm._items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }